var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "assignClient" },
    [
      _c(
        "v-card-title",
        { staticStyle: { height: "48px", "flex-wrap": "nowrap" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c("v-flex", [
                _c("span", { staticClass: "roomName" }, [_vm._v("Swap Client")])
              ])
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { xs: "", icon: "", flat: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.handleCancel()
                }
              }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c("div", { staticClass: "ntstSectionTitle" }, [_vm._v("Swap")]),
          _c(
            "v-layout",
            { staticClass: "detailsRow", attrs: { row: "" } },
            [
              _c("v-flex", [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Client")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(
                    _vm._s(
                      _vm.swapParams.fromValues.clientName.first +
                        " " +
                        _vm.swapParams.fromValues.clientName.last
                    )
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "v-layout",
            { staticClass: "detailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [_vm._v("Room")]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.swapParams.fromValues.roomName))
                ])
              ]),
              _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c("div", { staticClass: "ntstValueLabel" }, [_vm._v("Bed")]),
                  _vm.isEditable
                    ? _c("v-select", {
                        staticClass: "bedSelector ntstValue",
                        staticStyle: { width: "160px" },
                        attrs: {
                          disabled: !_vm.isEditable,
                          items: _vm.bedList(_vm.swapParams.fromValues),
                          "item-value": "bedBoardBedID.id",
                          outline: "",
                          "item-text": "name"
                        },
                        model: {
                          value: _vm.swapParams.fromValues.bedID.id,
                          callback: function($$v) {
                            _vm.$set(_vm.swapParams.fromValues.bedID, "id", $$v)
                          },
                          expression: "swapParams.fromValues.bedID.id"
                        }
                      })
                    : _vm._e(),
                  !_vm.isEditable
                    ? _c("div", [
                        _vm._v(_vm._s(_vm.swapParams.fromValues.bedName))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "ntstSectionTitle" }, [_vm._v("With")]),
          _c(
            "v-layout",
            { staticClass: "detailsRow", attrs: { row: "" } },
            [
              _c("v-flex", [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Client")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(
                    _vm._s(
                      _vm.swapParams.withValues.clientName.first +
                        " " +
                        _vm.swapParams.withValues.clientName.last
                    )
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "v-layout",
            { staticClass: "detailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [_vm._v("Room")]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.swapParams.withValues.roomName))
                ])
              ]),
              _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c("div", { staticClass: "ntstValueLabel" }, [_vm._v("Bed")]),
                  _vm.isEditable
                    ? _c("v-select", {
                        staticClass: "bedSelector ntstValue",
                        staticStyle: { width: "160px" },
                        attrs: {
                          disabled: !_vm.isEditable,
                          items: _vm.bedList(_vm.swapParams.withValues),
                          "item-value": "bedBoardBedID.id",
                          outline: "",
                          "item-text": "name"
                        },
                        model: {
                          value: _vm.swapParams.withValues.bedID.id,
                          callback: function($$v) {
                            _vm.$set(_vm.swapParams.withValues.bedID, "id", $$v)
                          },
                          expression: "swapParams.withValues.bedID.id"
                        }
                      })
                    : _vm._e(),
                  !_vm.isEditable
                    ? _c("div", [
                        _vm._v(_vm._s(_vm.swapParams.withValues.bedName))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "ntstAppButton",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.handleCancel()
                }
              }
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "ntstAppButton",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.handleSwap()
                }
              }
            },
            [_vm._v("\n      Swap\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }